import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3d5dc27d"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "tutor-team"
};
const _hoisted_2 = {
  class: "tutor-team-swiper-item"
};
const _hoisted_3 = ["src"];
import { Swiper, SwiperSlide } from "swiper/vue";
import { Pagination } from "swiper/modules";
// import required modules
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
export default /*#__PURE__*/_defineComponent({
  __name: 'course-tutor-team',
  emits: ["toTutorCollegeDetails"],
  setup(__props, {
    emit: emits
  }) {
    const modules = [Pagination];
    const teams = ["https://img2.qiuwenxinli.com/official-website/happiness-psychology-course/tutor-team-1.jpg", "https://img2.qiuwenxinli.com/official-website/happiness-psychology-course/tutor-team-2.jpg", "https://img2.qiuwenxinli.com/official-website/happiness-psychology-course/tutor-team-3.jpg"];
    function clickItem() {
      emits("toTutorCollegeDetails");
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(Swiper), {
        style: {
          '--swiper-theme-color': '#FFC56E'
        },
        modules: modules,
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        pagination: {
          clickable: true,
          dynamicBullets: true
        },
        onClick: clickItem,
        class: "tutor-team-swiper"
      }, {
        default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(teams, (item, index) => {
          return _createVNode(_unref(SwiperSlide), {
            key: index
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
              class: "tutor-team-swiper-item-img",
              src: item
            }, null, 8, _hoisted_3)])]),
            _: 2
          }, 1024);
        }), 64))]),
        _: 1
      })]);
    };
  }
});